// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__1gTIl","content":"ManualTimeModal_content__1Rff1"};